<template>
  <div v-if="!canUseCache">
    <popup-message v-if="loading" :visible="loading" :close="null">
      <my-loader css-classes="text-center pt-5 pb-5" label="Загружаем задачи..." />
    </popup-message>
    <popup-message v-else-if="loadingError" :visible="loadingError" :close="null">
      <info-block label="<span class='d-block'>Ошибка загрузки</span><span class='d-block pt-2'>Сейчас попробуем ещё раз...</span>" icon="bi-wifi-off" css-classes="text-danger"></info-block>
      <button type="button" @click="setCanUseCache(true)" class="btn btn-min-width btn-lg btn-primary rounded-pill">Не надо</button>
    </popup-message>
  </div>
  <shift-tasks-and-params-block v-else />
</template>

<script>
import { mapMutations, mapState } from "vuex";
import ShiftTasksAndParamsBlock from "@/components/ShiftTasksAndParamsBlock";

export default {
  components: {
    ShiftTasksAndParamsBlock,
  },
  computed: {
    ...mapState({
      loading: state => state.shifts.loading,
      loadingError: state => state.shifts.loadingError,
      canUseCache: state => state.shifts.canUseCache,
    }),
  },
  methods: {
    ...mapMutations({
      setCanUseCache: 'shifts/setCanUseCache',
    }),
  },
  mounted() {
    this.$store.dispatch('shifts/loop');
  }
}
</script>

<style lang="scss" scoped>
.separator {
  color: #222;
  font-size: 33px;
  text-align: center;
  line-height: 1;
}
</style>